import React from 'react';
import App from './App';
import {AuthProvider} from './context/AuthContext';
import {APIObjectsProvider} from './context/APIObjectsContext';
import {MiscProvider} from './context/MiscContext';
import {LicenseInfo} from '@mui/x-license-pro';
import {ThemeProvider} from '@mui/system';
import theme from './theme/theme';

//Setting MUI X pro license
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_X_PRO_LICENSE_KEY);

// we cannot use the context in the same component where it is being provided such as App.js.
// this is a wrapper for the rest of the children of the Provider
const ContextsWrapper = () => {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <MiscProvider>
          <APIObjectsProvider>
            <App />
          </APIObjectsProvider>
        </MiscProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default ContextsWrapper;
